export default __webpack_public_path__ + "static/media/Freelance.cdd6014a.webp";